function downloadFile (filename, text) {
  var element = document.createElement('a')
  element.setAttribute(
    'href',
    'data:text/plaincharset=utf-8,' + encodeURIComponent(text)
  )
  element.setAttribute('download', filename)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

function prettyJSON (code) {
  if (typeof code === 'object') {
    code = JSON.stringify(code)
  }

  var reserved = ['false', 'true', 'null']
  // reserved words
  code = code.replace(/(\w+)/g, function (v) {
    if (reserved.indexOf(v) !== -1) {
      return '<span class="rsv">' + v + '</span>'
    }
    return v
  })

  // numbers
  code = code.replace(/([0-9]+)/g, function (v) {
    return '<span class="num">' + v + '</span>'
  })

  // obj.method
  code = code.replace(/(\w+\.\w+)/g, function (v) {
    var t = v.split('.')
    return (
      '<span class="obj">' +
      t[0] +
      '</span>.<span class="prop">' +
      t[1] +
      '</span>'
    )
  })

  // strings
  code = code.replace(/('(\\.|[^'])*')/g, function (v) {
    return '<span class="str">' + v + '</span>'
  })

  // comments
  code = code.replace(/(\/\/[a-zA-Z0-9?!()_ ]*)/g, function (v) {
    return '<span class="cmnt">' + v + '</span>'
  })

  code = '<style>.obj { color: #79B; } .prop { color: #B97; } .str { color: #A79; } .num { color: #B97; } .cmnt { color: #798; } .rsv { color: #9AB; } </style>' + code

  return code
}

const state = {}
const getters = {}
const mutations = {}

const actions = {
  generateJSONFile ({ commit }, payload) {
    if (!payload.data || !payload.filename) {
      console.error('Error: Export Store :: generateJSONFile : data or filename are empty')
      return
    }
    var w = window.open('', '_blank')
    w.document.write('<style>* { margin: 0; padding: 0; } html,body { margin: 20px; background-color: #222; color: #eee; } </style>')
    var json = JSON.stringify(payload.data, null, '\t')
    var str = prettyJSON(json)
    w.document.write('<pre>' + str + '</pre>')
    w.document.close()
    downloadFile(payload.filename, json)
    return w
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
